import $ from 'jquery';

$(document).ready(() => {
	$('.js-scroll-to').bind('click', (event) => {
		const $link = $(event.currentTarget);
		const $target = $($link.attr('href').replace('/', ''));
		if ($target.length) {
			event.preventDefault();
			$('html, body').animate({ scrollTop: $target.offset().top }, 400);
		}
	});
});



// WEBPACK FOOTER //
// ./src/js/components/scroll-to.js